var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalIconAiHelp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_235_13848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 66C16 38.3858 38.3858 16 66 16C93.6142 16 116 38.3858 116 66V102.207C116 109.825 109.825 116 102.207 116H66C38.3858 116 16 93.6142 16 66Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 65.5C35 48.103 49.103 34 66.5 34C83.897 34 98 48.103 98 65.5V89.8228C98 93.7866 94.7867 97 90.8228 97H66.5C49.103 97 35 82.897 35 65.5Z",
    fill: "#196BDE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 65.5C35 48.103 49.103 34 66.5 34C83.897 34 98 48.103 98 65.5V89.8228C98 93.7866 94.7867 97 90.8228 97H66.5C49.103 97 35 82.897 35 65.5Z",
    fill: "#0B202C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0208 68.9461C64.0208 67.5349 64.3148 66.3148 64.9028 65.2858C65.5202 64.2568 66.5786 63.0808 68.078 61.7578C68.96 60.964 69.5921 60.2731 69.9743 59.6851C70.3859 59.0971 70.5917 58.4209 70.5917 57.6565C70.5917 56.7451 70.2536 55.9806 69.5774 55.3633C68.9012 54.7165 68.0045 54.3931 66.8873 54.3931C65.7113 54.3931 64.7411 54.7459 63.9767 55.4515C63.2417 56.1277 62.7125 56.9803 62.3891 58.0093L57.3176 55.8924C57.8762 54.0108 58.964 52.3938 60.581 51.0414C62.2274 49.6596 64.2854 48.9688 66.755 48.9688C68.6072 48.9688 70.2536 49.3363 71.6942 50.0713C73.1348 50.8063 74.252 51.8206 75.0458 53.1142C75.869 54.3784 76.2806 55.7896 76.2806 57.3477C76.2806 58.8766 75.9572 60.1849 75.3104 61.2727C74.6636 62.3605 73.7081 63.5071 72.4439 64.7125C71.4443 65.6533 70.7534 66.4618 70.3712 67.138C70.0184 67.8142 69.842 68.6668 69.842 69.6958V70.4014H64.0208V68.9461ZM66.8873 81.5146C65.8289 81.5146 64.9175 81.1471 64.1531 80.4121C63.4181 79.6477 63.0506 78.7363 63.0506 77.6779C63.0506 76.6195 63.4181 75.7228 64.1531 74.9878C64.9175 74.2528 65.8289 73.8853 66.8873 73.8853C67.9457 73.8853 68.8424 74.2528 69.5774 74.9878C70.3124 75.7228 70.6799 76.6195 70.6799 77.6779C70.6799 78.7363 70.3124 79.6477 69.5774 80.4121C68.8424 81.1471 67.9457 81.5146 66.8873 81.5146Z",
    fill: "#0B202C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0208 68.9461C64.0208 67.5349 64.3148 66.3148 64.9028 65.2858C65.5202 64.2568 66.5786 63.0808 68.078 61.7578C68.96 60.964 69.5921 60.2731 69.9743 59.6851C70.3859 59.0971 70.5917 58.4209 70.5917 57.6565C70.5917 56.7451 70.2536 55.9806 69.5774 55.3633C68.9012 54.7165 68.0045 54.3931 66.8873 54.3931C65.7113 54.3931 64.7411 54.7459 63.9767 55.4515C63.2417 56.1277 62.7125 56.9803 62.3891 58.0093L57.3176 55.8924C57.8762 54.0108 58.964 52.3938 60.581 51.0414C62.2274 49.6596 64.2854 48.9688 66.755 48.9688C68.6072 48.9688 70.2536 49.3363 71.6942 50.0713C73.1348 50.8063 74.252 51.8206 75.0458 53.1142C75.869 54.3784 76.2806 55.7896 76.2806 57.3477C76.2806 58.8766 75.9572 60.1849 75.3104 61.2727C74.6636 62.3605 73.7081 63.5071 72.4439 64.7125C71.4443 65.6533 70.7534 66.4618 70.3712 67.138C70.0184 67.8142 69.842 68.6668 69.842 69.6958V70.4014H64.0208V68.9461ZM66.8873 81.5146C65.8289 81.5146 64.9175 81.1471 64.1531 80.4121C63.4181 79.6477 63.0506 78.7363 63.0506 77.6779C63.0506 76.6195 63.4181 75.7228 64.1531 74.9878C64.9175 74.2528 65.8289 73.8853 66.8873 73.8853C67.9457 73.8853 68.8424 74.2528 69.5774 74.9878C70.3124 75.7228 70.6799 76.6195 70.6799 77.6779C70.6799 78.7363 70.3124 79.6477 69.5774 80.4121C68.8424 81.1471 67.9457 81.5146 66.8873 81.5146Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_235_13848",
    x: 0,
    y: 0,
    width: 132,
    height: 132,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.160156 0 0 0 0 0.211953 0 0 0 0 0.3125 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_235_13848"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_235_13848",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalIconAiHelp);
export default __webpack_public_path__ + "static/media/modal-icon-ai-help.397ebe74e914925170ab97b8407e1e55.svg";
export { ForwardRef as ReactComponent };